// import React from 'react'

// const Page404 = () => {
//   return (
//     <div className='mt-20'>Page404</div>
//   )
// }

// export default Page404;


import React from "react";
import { useLocation } from "react-router-dom";
import NoDataResponse from "../../Components/NoDataResponse";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";

const Page404 = () => {
  const location = useLocation();
  const userInfo = GetLocalStorage("UserInfo");

  const Wrapper = ({ children }) => (
    <div style={{ marginTop: "100px" }}>
      {children}
    </div>
  );

  // 🔐 Not logged in
  if (!userInfo?.User) {
    return (
      <Wrapper>
        <NoDataResponse
          topText="Login required"
          bottomText="Please login to access this page. Click the Vehicle Learning logo in the top-left to go to the main page, then press the Login button."
        />
      </Wrapper>
    );
  }

  const path = location.pathname;

  if (
    path.startsWith("/student") ||
    path.startsWith("/mycourses") ||
    path.includes("/enrolledcourse")
  ) {
    return (
      <Wrapper>
        <NoDataResponse
          topText="Access denied"
          bottomText="You cannot access this page unless you are a Learner."
        />
      </Wrapper>
    );
  }

  if (path.startsWith("/institute")) {
    return (
      <Wrapper>
        <NoDataResponse
          topText="Access denied"
          bottomText="You cannot access this page unless you are an Institute user."
        />
      </Wrapper>
    );
  }

  if (path.startsWith("/teacher") || path.startsWith("/instructor")) {
    return (
      <Wrapper>
        <NoDataResponse
          topText="Access denied"
          bottomText="You cannot access this page unless you are an Instructor."
        />
      </Wrapper>
    );
  }

  // ❓ Unknown route
  return (
    <Wrapper>
      <NoDataResponse
        topText="Page not found"
        bottomText="The page you are looking for does not exist."
      />
    </Wrapper>
  );
};

export default Page404;
